export default __webpack_public_path__ + "src/assets/images/security/sensor_door.png?fcd827f5";